import { render, staticRenderFns } from "./FloatImageCustoms.vue?vue&type=template&id=4670293a&scoped=true"
import script from "./FloatImageCustoms.vue?vue&type=script&lang=js"
export * from "./FloatImageCustoms.vue?vue&type=script&lang=js"
import style0 from "./FloatImageCustoms.vue?vue&type=style&index=0&id=4670293a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4670293a",
  null
  
)

export default component.exports